<template>
  <RcModal
    hideFooter
    id="findAccessModal"
    contentClass="rc-modal-access-point"
    size="lg"
  >
    <template #modal-title>
      {{ $t("auth.access_points.title") }}
    </template>

    <template #modal-body="{ cancel }">
      <RcFindAccessPoint :close="cancel" :public="public" />
    </template>
  </RcModal>
</template>

<script>
import RcFindAccessPoint from "#/pages/onboard/FindAccessPoint.vue";
import RcModal from "@/libvue/components/modal/Modal.vue";

export default {
  name: "RcFindAccessModal",

  components: {
    RcFindAccessPoint,
    RcModal
  },

  props: {
    public: {
      type: Boolean,
      default: false
    }
  }
};
</script>
